/* istanbul ignore file */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import styled, { css } from 'styled-components';
import { Box, Flex } from '@rebass/grid';

import { media } from 'app/shared/styles_js/variables';
import { ContentBoxSt } from 'app/shared/components/TabbedContent/ContentBox';
import {
  TabSt,
  TabsWrapperSt,
} from 'app/shared/components/TabbedContent/TabbedContent.css';

export const TabWrapperSt = styled.div`
  margin: 0 -24px;

  ${media.md(css`
    margin: 0;
  `)}

  ${TabsWrapperSt} {
    position: relative;
    padding: 0;
    margin: 0;
  }

  ${TabSt}.active {
    box-shadow: none;
  }

  ${ContentBoxSt} {
    padding: 32px;
    background-color: ${({ theme: { colors } }) => colors.sunbeanSuperLight};
  }
`;

export const FlexSt = styled(Box).attrs((props) => ({
  as: 'ul',
  pr: 0,
  pl: 0,
  ...props,
}))<{ showFullDetails: boolean | null }>`
  position: relative;
  display: block;
  margin: 0 0;
  list-style: none;
  columns: 1 auto;

  ${media.md(css`
    columns: 2 auto;
  `)}

  li {
    /* fix: safari issue of applying margin-bottom
    at the bottom of a column to the next one's top
    https://stackoverflow.com/a/44671098/5339853
    */
    display: inline-block;
    width: 100%;
    /* fix end */
    font-size: 16px;
    line-height: 2;
  }

  ${({ showFullDetails }) =>
    showFullDetails === false && // avoid applying style when undefined or null
    css`
      padding-right: 0;
      max-height: 320px;
      overflow: hidden;

      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 55px;
        background: linear-gradient(
          to bottom,
          rgba(245, 247, 251, 0) 0%,
          rgba(245, 247, 251, 1) 100%
        );
        bottom: 0;
        left: 0;
      }
    `};
`;

export const ErrorMessageSt = styled(Flex)`
  align-items: center;
  justify-content: center;
  margin: 48px 0 16px;

  & > span {
    font-size: 16px;
    color: ${({ theme: { colors } }) => colors.grayLight};
  }
`;
